module.exports = __webpack_public_path__ + "img/guidevideo.f546129f.jpg";